import { render, staticRenderFns } from "./VehicleStowage.vue?vue&type=template&id=80cc5568&scoped=true&"
import script from "./VehicleStowage.vue?vue&type=script&lang=js&"
export * from "./VehicleStowage.vue?vue&type=script&lang=js&"
import style0 from "./VehicleStowage.vue?vue&type=style&index=0&id=80cc5568&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cc5568",
  null
  
)

export default component.exports